import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

const GuidelinePackingShippingPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">梱包・発送ガイドライン</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
            <div className="self-stretch justify-center text-black text-base font-normal leading-7">
              DONDONでは、すべてのお取引がスムーズに進行するよう、梱包・発送に関するガイドラインを設けております。<br/>
              ガイドラインに沿わない梱包・発送が行われた場合、取引完了までにお時間を要することがあるほか、状況に応じて取引がキャンセルとなる可能性もございます。<br/>
              トラブルを未然に防ぐためにも、必ずガイドラインをご確認いただいたうえで、正しい手順での梱包・発送をお願いいたします。
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">発送方法</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">利用可能な配送業者例</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ヤマト運輸 / 佐川急便 / 日本郵便 / 西濃運輸 など
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">注意事項</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  ・追跡できない配送サービスや、伝票番号が9桁以下のサービスのご利用はご遠慮ください。<br/>
                  ・レターパック（追跡可能）はご利用いただけますが、商品サイズに適しているかをご確認のうえご利用ください。<br/>
                  ・定形外郵便（追跡不可）はご利用いただけません。破損・紛失等のトラブルが発生した場合、当社では責任を負いかねます。
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">発送手順</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">1. 十分に梱包を行う</div>
              <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  輸送中に角潰れやケース割れなどが発生しないよう、緩衝材や適切なサイズの箱・封筒を使用し、破損防止を心がけてください。
                </div>
                <div className="self-stretch flex flex-col justify-start items-start">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                    シングルカードは破損の可能性が特に高いため、以下のページに則った梱包を行ってください。
                  </div>
                  <Link to={`/terms/guideline_pack_single_card${location.search}`} className="self-stretch justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">
                    シングルカードの梱包方法
                  </Link>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">2. 伝票発行を行う</div>
              <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">
                  商品を発送する際は、必ず取引詳細に記載された住所宛にお送りください。<br/>
                  また、発送後は追跡番号を控えていただき、発送通知時に必ずご入力をお願いいたします。
                </div>
              </div>
              
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">送り先</div>
                <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="justify-center text-black text-base font-normal leading-7">
                    住所：150-0011 東京都渋谷区東2-22-5 シブロジ 3F<br/>
                    宛名：DONDON（取引ID） 宛
                  </div>
                </div>
              </div>
              
              <div className="pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">発送時の送料について</div>
                <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    DONDON宛に商品を発送する際は、必ず元払い（出品者様ご負担）にてご発送ください。<br/>
                    万が一、着払いで商品が到着した場合には、発生した送料をご請求させていただきます。<br/>
                    ご請求に対してお支払いいただけない場合は、アカウントのご利用を制限させていただくことがありますので、<br/>
                    あらかじめご了承ください。
                  </div>
                </div>
              </div>
              
              <div className="pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">日時指定について</div>
                <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                  <div className="flex-1 justify-center">
                    <span className="text-black text-base font-normal leading-7">DONDON宛に商品を発送する際は、最短での到着処理を行うため、</span>
                    <span className="text-black text-base font-bold leading-7">配達日時は「指定なし」に設定</span>
                    <span className="text-black text-base font-normal leading-7">してください。<br/>
                    DONDONに到着した荷物は、順次開封・確認を行い、それぞれの取引と照合したうえで、該当取引画面から「到着通知」を行います。<br/>
                    なお、DONDON上に表示される「到着日」は、運送会社の追跡情報上の配達完了日と一致しない場合がございますので、あらかじめご了承ください。<br/>
                    また、DONDONへの到着状況にかかわらず、出品商品の到着期限を超過した場合には、取引がキャンセルとなる可能性がございます。<br/>
                    キャンセルとなった際には、出品者様にキャンセル料が発生いたしますので、ご留意ください。<br/>
                    ※荷物の開封および取引との紐付けには、商品内容や量に応じてお時間をいただく場合があります。</span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">3. 発送通知を行う</div>
              <div className="self-stretch pl-5 inline-flex justify-center items-center gap-2.5">
                <div className="flex-1 justify-center">
                  <span className="text-black text-base font-normal leading-7">
                    商品を発送されましたら、必ず取引ページから発送通知を行い、追跡番号をお知らせください。<br/>
                    DONDONでは、ご申告いただいた追跡番号をもとに商品を受領・取引へ紐付けしております。<br/>
                    そのため、入力された伝票番号に誤りがある場合は、取引の進行に影響が出る可能性があります。<br/>
                    万が一、入力ミスなどにお気づきの際は、お問い合わせフォームよりご連絡ください。<br/><br/>
                    なお、発送通知を行っていない場合や、誤った情報を申告されたままの場合、<br/>
                    取引がキャンセルとなることがあり、その際は以下の対応となります。<br/>
                  </span>
                  <span className="text-black text-base font-normal leading-7">
                    ・商品は着払い（出品者様負担）で返送されます<br/>
                    ・キャンセル料（商品代金の10％）が発生します<br/>
                  </span>
                  <span className="text-black text-base font-normal leading-7">
                    安全かつスムーズな取引のため、発送通知と情報入力は忘れずにおこなってください。
                  </span>
                </div>
              </div>
              
              <div className="pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">追跡番号の入力ができない場合</div>
                <div className="self-stretch pl-5 flex flex-col justify-center items-start gap-2.5">
                  <div className="justify-center">
                    <span className="text-black text-base font-normal leading-7">
                      追跡番号の入力が困難な場合（紛失等）は、以下の情報を添えて取引メッセージまたはお問い合わせフォームよりご連絡ください。<br/>
                    </span>
                    <span className="text-black text-base font-normal leading-7">
                      ・利用した運送会社<br/>
                      ・発送日時（引き渡し日）
                    </span>
                  </div>
                  <div className="justify-center">
                    <span className="text-black text-base font-normal leading-7">
                      発送期限内に追跡番号の入力が確認できない場合や、誤った番号により商品の追跡ができない場合は、購入者様の判断により取引がキャンセルとなる場合があります。<br/>
                      追跡番号を誤って入力してしまった場合は、速やかに
                    </span>
                    <a href="/contact" className="text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">
                      お問い合わせフォーム
                    </a>
                    <span className="text-black text-base font-normal leading-7">
                      からご連絡ください。<br/>
                      虚偽（架空）の追跡番号による発送通知は固くお断りいたします。<br/>
                      海外からの発送はDONDONで禁止されております。必ず国内から発送してください。
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">まとめて（同梱）発送する場合</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">
                  取引が複数ある場合には、同梱のうえまとめてご発送いただくことができます。
                </div>
                <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                  各商品には、跡の残らない付箋などに「取引ID」を記載し、必ず同梱してください。<br/>
                  取引IDの記載がない、または不明確な場合、取引との紐づけに時間を要するだけでなく、誤って別の取引に商品が紐づく可能性がございます。<br/>
                  お客様のご意向とは異なる処理が行われる恐れもありますので、あらかじめご了承ください。
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">注意事項</div>
                <div className="pl-5 inline-flex justify-start items-start gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    ・複数の商品をまとめて（同梱）発送される場合でも、必ず取引ごとに個別で発送通知を行ってください。<br/>
                    ・ご自身以外のアカウント（例：ご友人など）の取引商品とまとめて発送することはご遠慮ください
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">発送・到着期限</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">発送期限</div>
              <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  原則として取引成立後は72時間以内にご発送いただいております。<br/>
                  取引成立後、自動的に72時間のカウントダウンが開始されます。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">到着期限</div>
              <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  到着期限は、発送通知日を0日として+5日目の23:59です。<br/>
                  【例】<br/>
                  ・04/01 21:00に発送通知した場合の到着期限：04/06 23:59
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">DONDONにおける「到着」について</div>
              <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  運送会社からDONDONに到着した荷物は、順次開封され、伝票情報をもとに取引との照合が行われます。<br/>
                  商品の内容や数量によって取引の特定にかかる時間が異なるため、DONDONでは「取引への紐付け」が完了した時点を「到着」と定義しています。<br/>
                  ※取引件数が増加している場合や、配達時間によっては翌日以降の受取処理となる場合がございます。あらかじめご了承ください。<br/>
                  商品の到着が確認されると、該当の取引画面にて、出品者様・購入者様の双方に通知が届きます。
                </div>
              </div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">到着期限を超過した場合</div>
              <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  購入者様の取引画面に「キャンセルボタン」が表示されます。<br/>
                  購入者様がキャンセルを選択し、取引がキャンセルとなった場合には、出品者様にキャンセル料（商品代金の10％）が発生いたします。<br/>
                  なお、DONDONに到着済みの商品については、原則として着払い（出品者様ご負担）で返送いたしますので、あらかじめご了承ください。
                </div>
              </div>
            </div>
            
            <div className="self-stretch flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">災害や交通状況による到着期限超過時の対応</div>
              <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                  自然災害や交通規制などの影響によって配送に遅延が発生した場合でも、到着期限およびそれに伴う対応は一律となります。<br/>
                  配送トラブルや配達状況に関する詳細の確認をご希望の場合は、ご利用の運送会社へ直接お問い合わせください。
                </div>
              </div>
              
              <div className="self-stretch pl-5 flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-base font-bold leading-7">出品者</div>
                <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    配送に遅延が発生している場合でも、到着期限を過ぎた際には、購入者様のご意向により取引がキャンセルとなる可能性がありますのでご注意ください。<br/>
                    災害・交通規制・連休などの影響によって配送に遅れが生じている場合は、事務局までご連絡をお願いいたします。<br/>
                    ご申告いただいた状況を踏まえたうえで、今後の対応についてあらためてご案内いたします。
                  </div>
                </div>
                
                <div className="justify-center text-black text-base font-bold leading-7">購入者</div>
                <div className="self-stretch pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    出品者様よりDONDON宛に発送された商品については、配送の遅延により到着までにお時間を要する場合がございます。<br/>
                    到着期限を過ぎた際には、取引をキャンセルしていただくことも可能ですが、もしお時間に余裕がございましたら、そのまま商品到着をお待ちいただけますと幸いです。
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">注意事項</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">DONDON到着後の梱包資材の取扱について</div>
                <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    梱包資材は、商品到着後に当社にて処分いたします。<br/>
                    そのため、発送時に使用された箱や袋などの返送は承っておりません。<br/>
                    また、万が一取引がキャンセルとなった場合には、事務局で用意している外装資材の中から、商品に合った適切なサイズの梱包で返送いたします。<br/>
                    ※その際、ご発送時と返送時の梱包サイズが異なる場合がございますので、あらかじめご了承ください。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">発送通知後の未到着商品への対応について</div>
                <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    発送通知日から6日が経過しても、DONDONに該当商品の到着が確認できない場合、取引がキャンセルとなる可能性があります。<br/>
                    万が一、発送に遅れが生じている場合は、必ず事前にお問い合わせフォームよりご連絡をお願いいたします。<br/>
                    ※取引がキャンセルとなった場合は、キャンセル料（商品代金の10％）が発生いたしますので、ご注意ください。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">ご申告内容と到着した荷物の伝票番号が一致しない</div>
                <div className="pl-5 inline-flex justify-center items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    発送時にご連絡いただいた伝票番号と異なる番号で商品が到着した場合、伝票番号の不一致により、該当取引への紐付け・反映ができません。<br/>
                    複数の取引を同時に行っている場合は、取引ごとに正しい伝票番号を申告し、番号の入れ違いがないようご注意ください。<br/>
                    なお、伝票番号の不一致により取引の特定ができず、商品との紐づけが不可能な場合は、該当の取引をキャンセルし、商品は着払い（出品者様負担）にて返送させていただきます。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">商品が欠品していた場合</div>
                <div className="pl-5 flex flex-col justify-center items-start gap-2.5">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                    商品に欠品が確認された場合は、当社よりご連絡させていただきます。<br/>
                    その際は、該当商品の有無についてご確認をお願いいたします。
                  </div>
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                    ※購入者様のご希望により、取引をキャンセルとさせていただく場合がございます。<br/>
                    ※なお、取引がキャンセルとなった場合は、キャンセル料（商品代金の一部）が発生いたしますので、あらかじめご了承ください。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">DONDONへ入荷時、梱包材に破損・汚損がみられた場合</div>
                <div className="pl-5 flex flex-col justify-center items-start gap-2.5">
                  <div className="self-stretch justify-center text-black text-base font-normal leading-7">
                    一般的な配送過程において、梱包材にある程度のダメージが生じることは想定内であるため、著しい破損・汚損が確認された場合を除き、当社ではすべて受領対応いたします。<br/>
                    なお、当社入荷時に確認された梱包材の状態については、出品者様への個別のご報告は行っておりません。<br/>
                    また、梱包材のダメージは商品の鑑定・検品評価に影響いたしません。商品そのものの状態をもとに鑑定・検品を行いますので、あらかじめご了承ください。<br/>
                    ※鑑定・検品においてガイドライン基準を満たさない場合は、該当取引がキャンセルとなることがあります。
                  </div>
                  
                  <div className="flex flex-col justify-start items-start">
                    <div className="justify-center text-black text-base font-bold leading-7">【梱包材に生じた破損・汚損が著しい場合】</div>
                    <div className="justify-center text-black text-base font-normal leading-7">
                      内部の商品に影響が及んでいる可能性がある場合には、当社判断により運送会社へ持ち戻り（返送）を依頼することがあります。<br/>
                      このような場合、当社では該当の荷物の受領を行わず、関連する取引については事務局判断のもとキャンセルとなりますので、あらかじめご了承ください。<br/>
                      なお、配送時における破損や損傷等について補償をご希望される場合には、お客様ご自身でご利用の運送会社へ補償をお申し出いただきますようお願いいたします。
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">禁止事項</div>
            </div>
            
            <div className="flex flex-col justify-start items-start gap-5">
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">登録住所・氏名・電話番号以外での発送は禁止</div>
                <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    商品を発送する際は、DONDONに登録されている「住所・氏名・電話番号」を正確に伝票へ記載し、必ず元払いでご発送ください。<br/>
                    登録情報と異なる内容で配送された場合、商品と取引の照合ができず、取引の進行に支障が生じる可能性がありますのでご注意ください。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">商品にシールなどを貼らない</div>
                <div className="pl-5 inline-flex justify-start items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    カード本体やボックス本体には、シール類を貼らないようお願いいたします。<br/>
                    シールを剥がす際に商品が破損する恐れがあるため、万が一シールが貼られている状態で商品が届いた場合は、取引がキャンセルとなる可能性があります。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">不用品を同梱しない</div>
                <div className="pl-5 flex flex-col justify-center items-start gap-2.5">
                  <div className="justify-center text-black text-base font-normal leading-7">
                    取引と無関係な品物が同梱されていないか、発送前に必ずご確認ください。<br/>
                    万が一、関係のない物品が同梱されていた場合は、検品時に取り除いたうえで、DONDONにて破棄させていただきます。
                  </div>
                  <div className="justify-center text-black text-base font-normal leading-7">
                    商品が過剰に届いた場合は、当社にて確認のうえ、着払い（出品者様ご負担）にて返送させていただきます。<br/>
                    また、取引が成立する前の商品発送は固くお断りしております。<br/>
                    誤って発送されないよう、十分にご注意ください。
                  </div>
                </div>
              </div>
              
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-xl font-bold leading-[30px]">他サイトから直送しない</div>
                <div className="pl-5 inline-flex justify-center items-center gap-2.5">
                  <div className="flex-1 justify-center text-black text-base font-normal leading-7">
                    他サイトで購入した商品を、そのままDONDONへ直送する行為は禁止されています。<br/>
                    必ずご自身で商品を受け取り、内容や状態をご確認のうえ、適切な梱包・発送を行ってください。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default GuidelinePackingShippingPage;